import { Text, TouchableOpacity, View } from 'react-native'
import { Icon } from 'react-native-elements'
import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '../../styles'
import listMenuItemStyles from '../../styles/listMenuItem'
import { checkHyphenation } from '../../utils'

export default function SectionPanel(props) {
  const {
    t,
    titleKey,
    descriptionKey,
    onPress,
    testID,
    children,
  } = props

  return (
    <TouchableOpacity onPress={onPress} testID={testID}>
      <View
        style={listMenuItemStyles.sectionPanelView}
        underlayColor={colors.white}
      >
        <View style={{ justifyContent: 'space-between', flexDirection: 'row' }}>
          <View style={[listMenuItemStyles.listItemTextView, {
            flex: 1,
            flexShrink: 1,
}]}
          >
            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 8 }}>
              {children}
              <Text style={listMenuItemStyles.sectionPanelTitle}>{checkHyphenation(t(titleKey))}</Text>
            </View>

            <Text style={listMenuItemStyles.listItemText}>
              {t(descriptionKey)}
            </Text>
          </View>
          <Icon
            name="chevron-right"
            type="material-community"
            size={24}
            color={colors.raven_grey}
            style={[listMenuItemStyles.listItemChevron, {
              flex: 1,
              flexShrink: 1,
            }]}
          />
        </View>
      </View>
    </TouchableOpacity>
  )
}

SectionPanel.propTypes = {
  t: PropTypes.func.isRequired,
  titleKey: PropTypes.string.isRequired,
  descriptionKey: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  testID: PropTypes.string.isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
}
